/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The physician to mark as default, or null to clear the default.
 * @export
 * @interface SetDefaultFacilityPhysicianRequestPhysicianId
 */
export interface SetDefaultFacilityPhysicianRequestPhysicianId {
}

/**
 * Check if a given object implements the SetDefaultFacilityPhysicianRequestPhysicianId interface.
 */
export function instanceOfSetDefaultFacilityPhysicianRequestPhysicianId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetDefaultFacilityPhysicianRequestPhysicianIdFromJSON(json: any): SetDefaultFacilityPhysicianRequestPhysicianId {
    return SetDefaultFacilityPhysicianRequestPhysicianIdFromJSONTyped(json, false);
}

export function SetDefaultFacilityPhysicianRequestPhysicianIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultFacilityPhysicianRequestPhysicianId {
    return json;
}

export function SetDefaultFacilityPhysicianRequestPhysicianIdToJSON(value?: SetDefaultFacilityPhysicianRequestPhysicianId | null): any {
    return value;
}

